'use client'

import React from 'react'
import { SoftCategoryContentType } from '@contentsite/src/graphql/generated/graphql-types'
import MacroContent from '@contentsite/src/components/macros/macro-content'
import cssToJs from '@contentsite/src/components/utils/css-to-js'
import { SoftCategoryContentSchema } from '@contentsite/src/components/schemas/collection-page-schema'

type SoftCategoryContentItem = {
  categoryPath?: string | null
  contentHeader?: string | null
  contentType: SoftCategoryContentType
  textContent?: string | null
  cssClass?: string | null
  cssStyle?: string | null
  outerCssClass?: string | null
  outerCssStyle?: string | null
}

type Props = {
  page: {
    title?: string
    pageHeader?: string | null
    metaDescription?: string | null
    metaKeywords?: string | null
    noIndex?: boolean
    breadcrumbs?: Array<{
      displayName?: string
      url?: string
    }>
    softCategoryPageContent?: Array<SoftCategoryContentItem>
  }
}

const SoftCategoryPageWrapper = ({ page }: Props) => {
  return (
      <SoftCategoryPage page={page} />
  )
}

const SoftCategoryPage = ({ page }: Props) => {

  return (
     <div id="page-container" className="c-filter">
      <SoftCategoryContentSchema page={page} />
      {page?.softCategoryPageContent
        ?.filter(c => c.contentType === SoftCategoryContentType.HtmlBlock)
        .map((htmlBlock, index) => {
          const outerClassName = htmlBlock.outerCssStyle ?? ''
          const outerStyleStr = htmlBlock.outerCssClass ?? ''
          return (
            <div key={index} className={outerClassName || undefined} style={cssToJs(outerStyleStr)}>
              <div className="container" style={cssToJs(htmlBlock.cssStyle)}>
                <div className="row">
                  <MacroContent content={htmlBlock.textContent ?? ''} />
                </div>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default SoftCategoryPageWrapper
